module.exports = __webpack_public_path__ + "img/insurance-logo-15.f3b1c870.png";